import { Injectable, inject } from '@angular/core';
import { HttpBackend, HttpClient } from '@angular/common/http';
import { Config } from './conf';

/**
 * Service permettant de charger la configuration d'une application
 * à partir d'un fichier json (en général assets/config.json)
 */
@Injectable()
export class ConfigService {
    private config = inject(Config);

    private httpClient: HttpClient;

    /**
     * See https://stackoverflow.com/a/57007667
     * for explanation HttpBackend usage and not Http
     * I don't want interceptors here
     */
    constructor() {
        const handler = inject(HttpBackend);

        this.httpClient = new HttpClient(handler);
    }

    private configSettings: any = null;

    getConfig(): any {
        if (this.configSettings === null) {
            throw new Error('Configuration not available (has not been loaded)');
        }
        return this.configSettings;
    }

    public load(): Promise<any> {
        const promise = this.httpClient
            .get(this.config.location)
            .toPromise()
            .then(data => {
                this.configSettings = data;
                return data;
            });
        return promise;
    }
}
